import { Row as RowBase } from '@hud/web-components/Layout/Layout';
import styled from 'styled-components';
import { LineChart } from '@hud/web-components/Charts/LineChart/LineChart';
import { Container as BaseContainer } from '@hud/web-components/Container/Container';
import { themeColor } from '@hud/web-components/theme/colors';
import { xxsRegular } from '@hud/web-components/theme/typography';

export const Row = styled(RowBase)`
  max-height: 400px;
`;

export const FunctionBehaviorContainer = styled.div`
  flex: 1;
`;

export const FunctionBehaviorChartContainer = styled(BaseContainer)`
  flex: 1;
  overflow: hidden;
`;

export const FunctionsLineChart = styled(LineChart)`
  transform: translateY(-40px);
`;

export const MethodsTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const MethodLabel = styled.div`
  display: flex;
  height: 22px;
  width: fit-content;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  ${xxsRegular};

  border-radius: 6px;
  border: 1px solid ${themeColor('strokeSecondary')};
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
  color: ${themeColor('turquoise')};
`;
